import React from 'react';

import './info.scss';

export const Info = () => {
  return (
    <div className="info">
      <p>I</p>
      <div className="info__content"></div>
    </div>
  );
};
